import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { useHashFragment } from '../../useHashFragment';
import WBRString from '@component/WbrString';

const BodyCopyComponent = (props) => {
  useHashFragment();

  return (
    <>
      <WBRString class="richtext" tag="div">
        <RichText field={props.fields.bodycopy} />
      </WBRString>
    </>
  );
};
export default BodyCopyComponent;
